const DEFAULT_DELTA = 2

export function getDeltas(currentPage: number, nbPages: number) {
  let AFTER_CURRENT_PAGE_DELTA = DEFAULT_DELTA

  switch (currentPage) {
    case 1:
      AFTER_CURRENT_PAGE_DELTA = 4
      break
    case 2:
      AFTER_CURRENT_PAGE_DELTA = 3
      break
    default:
      AFTER_CURRENT_PAGE_DELTA = DEFAULT_DELTA
  }

  let BEFORE_CURRENT_PAGE_DELTA = DEFAULT_DELTA

  switch (currentPage) {
    case nbPages:
      BEFORE_CURRENT_PAGE_DELTA = 4
      break
    case nbPages - 1:
      BEFORE_CURRENT_PAGE_DELTA = 3
      break
    default:
      BEFORE_CURRENT_PAGE_DELTA = DEFAULT_DELTA
  }

  return {
    BEFORE_CURRENT_PAGE_DELTA,
    AFTER_CURRENT_PAGE_DELTA,
  }
}
